let _URLChangeInterval;
const timeout = 250;

/**
 * Trigger passed callback function when URL change
 * 
 * @memberof _helpers 
 * @param {Function} callback 
 */
function whenURLChange(callback) {
    if (_URLChangeInterval) {
        clearInterval(_URLChangeInterval);
    }

    let prevURL;

    // eslint-disable-next-line
    function checkURLchange() {
        if (window.location.href === prevURL) { return; }
        if (typeof callback === 'function') { callback(); }
        prevURL = window.location.href;
        _URLChangeInterval = setInterval(checkURLchange, timeout);
    }

    checkURLchange();

}

export default whenURLChange;